import API from 'utils/api';

export const baseURL = '/estructura-organizacional/entidad-logotipo-publico/';

/**
 * GET Logotipo público de la Entidad (sin autenticación, para la pantalla de login)
 * Regresa `null` si la Entidad no tiene logotipo configurado (el backend manda un
 * logo de reserva marcado con `es_default`), para que el llamador use el suyo.
 * @returns {Promise<string|null>}
 */
export const getEntidadLogotipoPublico = async () => {
  try {
    const response = await API.get(baseURL);
    if (response.data?.es_default) return null;
    return response.data?.logotipo || null;
  } catch (err) {
    return null;
  }
};
